import { Seo } from '@/seo/Seo'
import { pageJsonLd } from '@/seo/structuredData'
import { LegalLayout } from './LegalLayout'

/**
 * Terms of Service. NOTE TO TEAM: structural starter draft to satisfy the
 * ads-platform landing-page requirement — NOT legal advice. Have counsel review
 * and set the governing jurisdiction before relying on it.
 */
export function TermsPage() {
  return (
    <>
      <Seo
        title="Terms of Service — Zenzers Geriatric Remote Monitoring"
        description="The terms governing use of the Zenzers geriatric remote monitoring platform, hardware, accounts, subscriptions, and the medical-use disclaimer."
        path="/terms"
        jsonLd={pageJsonLd({
          path: '/terms',
          name: 'Terms of Service',
          description: 'The terms governing use of the Zenzers platform and hardware.',
        })}
      />
      <LegalLayout title="Terms of Service" updated="June 10, 2026">
        <p>
          These terms govern your use of the Zenzers geriatric remote monitoring platform, hardware,
          and related services. By creating an account or using the service, you agree to them.
        </p>

        <h2>Accounts</h2>
        <p>
          You are responsible for keeping your credentials secure and for activity under your
          account. Provide accurate information and keep it current.
        </p>

        <h2>Purchases &amp; subscriptions</h2>
        <p>
          Hardware is sold as listed; monitoring is offered as a recurring subscription. Payments and
          renewals are handled by our payment provider. You may cancel a subscription as described in
          your account; access continues through the paid period.
        </p>

        <h2>Medical-use disclaimer</h2>
        <p>
          Zenzers supports caregivers and clinicians with monitoring and alerts. It is{' '}
          <strong>not a substitute for professional medical judgment</strong> and is{' '}
          <strong>not an emergency response service</strong>. In an emergency, call your local
          emergency number.
        </p>

        <h2>Acceptable use</h2>
        <p>
          Do not misuse the service, attempt to disrupt it, or use it unlawfully. We may suspend
          accounts that violate these terms.
        </p>

        <h2>Intellectual property</h2>
        <p>
          The Zenzers name, software, and content are owned by Zenzers Inc. and may not be copied or
          reused without permission.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          To the extent permitted by law, Zenzers is not liable for indirect or consequential damages
          arising from use of the service. Nothing here limits liability that cannot be limited by law.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these terms; material changes will be posted here with a new effective date.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about these terms: <a href="mailto:hello@zenzers4life.com">hello@zenzers4life.com</a>.
        </p>
      </LegalLayout>
    </>
  )
}
